module.exports = __webpack_public_path__ + "static/media/RR-Voronoi.de7d4924.gif";